import Lottie from 'lottie-react-web';
import React from 'react';
import { Center, RegularText } from 'src/components';
import { AppColors } from 'src/themes/Colors';
import { pixelScaler } from 'src/themes/Metrics';

export const LoadingView = () => {
  return (
    <Center>
      <Lottie
        height={pixelScaler(100)}
        width={pixelScaler(100)}
        options={{
          autoplay: true,
          loop: true,
          animationData: require('src/assets/lotties/loading-bus.json'),
        }}
      />
      <RegularText fontSize="medium" color={AppColors.gray}>
        Your result will appear in just a second!
      </RegularText>
    </Center>
  );
};
